import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject} from '@angular/core';
import {I18nService} from '../../../_services/gui/i18n.service';
import {TabBarService} from '../../../_services/gui/tab-bar.service';
import {ConsumerReportsService} from '../../../_services/data/reports/consumer-reports.service';
import {reformatDate} from '../../../_utils/lang';
import {ConsumerReport} from '../../../_data/reports/consumer/consumer-report';
import {ConsumerRequest} from '../../../_data/reports/consumer/consumer-request';
import {Router} from '@angular/router';
import {tap} from 'rxjs/operators';
import {exists} from '../../../_utils/operators';
import {NotificationService} from '../../../_services/gui/notification.service';
import {CONSUMER_PDF_CSS} from '../../../_constants/pdf-report/consumer-css';
import {CONSUMER_REQUEST_CACHE_KEY, CONSUMER_RESPONSE_CACHE_KEY, IFS_REQUEST_CACHE_KEY, MDS_REQUEST_CACHE_KEY} from '../../../_constants/constants';
import {fromSessionOr} from '../../../_utils/storage';
import {isAml, isEbvsid, isMds} from '../../../_utils/products';
import {isAnyHit, primaryName} from '../../../_utils/consumer';
import {PdfReactorHeaderComponent} from '../../../common/pdf-reactor-header/pdf-reactor-header.component';
import {SidenavComponent} from '../../../sidenav/sidenav.component';
import {CardComponent} from '../../../sidenav/card/card.component';
import {ConsumerCreditReportSidenavComponent} from './consumer-sidenav/consumer-credit-report-sidenav.component';
import {PdfButtonBarComponent} from '../../../common/pdf-button-bar/pdf-button-bar.component';
import {ConsumerCreditReportContentComponent} from './consumer-credit-report-content/consumer-credit-report-content.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-consumer-credit-report',
    templateUrl: './consumer-credit-report.component.html',
    styleUrls: ['./consumer-credit-report.component.scss'],
    imports: [SidenavComponent, PdfReactorHeaderComponent, CardComponent, ConsumerCreditReportSidenavComponent, 
      PdfButtonBarComponent, ConsumerCreditReportContentComponent, TranslateModule]
})
export class ConsumerCreditReportComponent implements OnInit, OnDestroy {

  _logo: ElementRef;
  _appCard: ElementRef;
  _creditReport: ElementRef;

  consumerReportCss = CONSUMER_PDF_CSS;

  reformatDate = reformatDate;
  primaryName = primaryName;
  isAnyHit = isAnyHit;

  consumerReport: ConsumerReport;
  consumerRequest: ConsumerRequest;
  
  i18nService = inject(I18nService);
  private router = inject(Router);
  private tabBarService = inject(TabBarService);
  private consumerReportsService = inject(ConsumerReportsService);
  private notificationService = inject(NotificationService);
  private cdRef = inject(ChangeDetectorRef);

  constructor() {
    const router = this.router;

    this.consumerRequest = JSON.parse(sessionStorage.getItem(CONSUMER_REQUEST_CACHE_KEY));

    if(!this.consumerRequest) {
      console.warn('Consumer request data missing');
      router.navigateByUrl('/consumer-services');
    }
  }

  ngOnInit() {
    this.i18nService.setTitle('title.consumer-report');
    this.tabBarService.show();

    fromSessionOr(CONSUMER_RESPONSE_CACHE_KEY, this.consumerReportsService.getReport(this.consumerRequest)).pipe(
      tap(report => {
        if(!report) {
          this.notificationService.displayI18n('content.report.messages.report-failed');
          console.error('Report null.');
        }
      }),
      exists()
    ).subscribe(report => {
      console.info('Report received');
      this.consumerReport = report.body;
      if(isAml(this.consumerRequest.metaInfo.product) || (isEbvsid(this.consumerRequest.metaInfo.product))) {
        console.info('Redirecting to IFS view...');
        sessionStorage.setItem(IFS_REQUEST_CACHE_KEY, JSON.stringify({req: this.consumerRequest, report: this.consumerReport}));
        this.router.navigateByUrl('/consumer-services/ifs-report');
      } else if(isMds(this.consumerRequest.metaInfo.product)) {
        console.info('Redirecting to MDS view...');
        sessionStorage.setItem(MDS_REQUEST_CACHE_KEY, JSON.stringify({req: this.consumerRequest, report: this.consumerReport}));
        this.router.navigateByUrl('/consumer-services/mds-report');
      }
    });
  }

  ngOnDestroy() {
    //If the user intentionally navigates away from the report, clear the storage for the request/response.
    console.debug('Credit report component teardown.');
    sessionStorage.removeItem(CONSUMER_REQUEST_CACHE_KEY);
    sessionStorage.removeItem(CONSUMER_RESPONSE_CACHE_KEY);
  }

  set creditReport(value: ElementRef) {
    this._creditReport = value;
    this.cdRef.detectChanges();
  }

  @ViewChild(PdfReactorHeaderComponent, {read: ElementRef})
  set appCard(appCard: ElementRef) {
    this._appCard = appCard;
    this.cdRef.detectChanges();
  }

  @ViewChild('logo', {read: ElementRef})
  set logo(appCard: ElementRef) {
    this._logo = appCard;
    this.cdRef.detectChanges();
  }
}
